<template>
<!-- NAVBAR -->
<nav id="navbar" class="navbar fixed-top navbar-expand-lg navbar-header navbar-mobile">
    <div class="navbar-container container">
        <!-- LOGO -->
        <div class="navbar-brand">
        <a class="navbar-brand-logo" href="#">
            <img src="../assets/images/logo.svg" width="240px">
        </a>
        </div>
        <button class="navbar-toggler" 
                type="button" 
                data-toggle="collapse" 
                data-target="#navbarNav" 
                aria-controls="navbarNav" 
                aria-expanded="false" 
                aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-around" id="navbarNav">
            <ul class="navbar-nav menu-navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" href="#services">
                        <p class="nav-link-menu">Wat is Family Portal?</p>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#howto">
                        <p class="nav-link-menu">Hoe werkt het?</p>
                    </a>
                </li>
            </ul>
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link learn-more-btn btn-invert" href="#pricing">Prijzen</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link learn-more-btn btn-invert" href="#">Download App</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
</template>

<script>
$(window).scroll(function() {
    if ($(this).scrollTop() > 20) {
        $('#navbar').addClass('header-scrolled');
    } else {
        $('#navbar').removeClass('header-scrolled');
    }
});	

export default {
    
}
</script>

<style scoped>

</style>